export default "__VITE_ASSET__DW4d67wa__"